import { ArrowRight } from "lucide-react";
import { StepShell, Eyebrow, BottomBar, PrimaryButton, Choice } from "./ui";

export const QuestionTitle = ({ children, hint }) => (
  <div className="mb-6">
    <h2 className="font-display text-[1.7rem] font-medium leading-tight text-[#1f2328] sm:text-4xl">{children}</h2>
    {hint && <p className="mt-2 text-sm text-neutral-500">{hint}</p>}
  </div>
);

export const OptionsStep = ({ id, eyebrow, title, hint, options, value, onPick, onBack, progress }) => (
  <StepShell stepKey={id} onBack={onBack} progress={progress} testId={`question-${id}`}>
    {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
    <QuestionTitle hint={hint}>{title}</QuestionTitle>
    <div className="space-y-3 pb-6">
      {options.map((o, i) => (
        <Choice key={o} selected={value === o} onClick={() => onPick(o)} data-testid={`option-${id}-${i}`}>
          {o}
        </Choice>
      ))}
    </div>
  </StepShell>
);

export const MultiStep = ({ id, title, hint, options, value = [], max, onChange, onNext, onBack, progress }) => {
  const toggle = (o) => {
    if (value.includes(o)) onChange(value.filter((v) => v !== o));
    else if (value.length < max) onChange([...value, o]);
  };
  return (
    <StepShell stepKey={id} onBack={onBack} progress={progress} testId={`question-${id}`}>
      <QuestionTitle hint={hint}>{title}</QuestionTitle>
      <div className="flex flex-wrap gap-2.5 pb-6">
        {options.map((o, i) => {
          const on = value.includes(o);
          const disabled = !on && value.length >= max;
          return (
            <button
              key={o}
              onClick={() => toggle(o)}
              disabled={disabled}
              data-selected={on ? "true" : "false"}
              className="choice min-h-[44px] rounded-full border border-neutral-200 px-4 py-2 text-sm font-medium text-[#1f2328] disabled:opacity-40"
              data-testid={`option-${id}-${i}`}
            >
              {o}
            </button>
          );
        })}
      </div>
      <p className="text-xs text-neutral-500" data-testid="priorities-count">{value.length} of {max} selected</p>
      <BottomBar>
        <PrimaryButton disabled={!value.length} onClick={onNext} data-testid={`question-${id}-continue`}>
          Continue <ArrowRight className="h-5 w-5" />
        </PrimaryButton>
      </BottomBar>
    </StepShell>
  );
};
